<template>
  <div   class="creditcard">
    <div><span style="text-transform: uppercase;">{{ cardInfo.brand }}</span> ending in {{ cardInfo.last4 }}. Expires: {{ cardInfo.exp_month }}/{{ cardInfo.exp_year }}</div>
    <div class="icon-div">
      <button  class="btn default" v-if="cardInfo.default">Default</button>   
      <button  class="btn not-default" @click="defaultHandler(cardInfo.id)" v-else >Set Default</button>         
      <button class="icn"  @click="deleteHandler(cardInfo.id)">
              <SVGIcon
                :iconName="'delete'"
                :width="'20px'"
                :height="'20px'"
              />
      </button>
    </div>
   
  </div>
</template>

<script setup>
import SVGIcon from '@/components/SVGIcon.vue';
import { defineEmits , ref, nextTick, computed} from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

const emit = defineEmits(['card_updated']);
const props = defineProps({ cardInfo: Object});

async function  deleteHandler(id) {
  const dsConn = new DatastoreConnect();
  const ret = await dsConn.deleteCard({ card_id: id});

  if (ret.result) {
      emit('card_updated','');
  }
}

async function  defaultHandler(id) {
  const dsConn = new DatastoreConnect();
  const ret = await dsConn.defaultCard({ card_id: id});

  if (ret.result) {
      emit('card_updated','');
  }
}
</script>

<style lang="scss" scoped>

.creditcard {
  max-width: 600px;
  min-width: 400px;
  margin-top: 4px;
  padding: 2px 8px 2px 8px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border: 2px solid rgb(220, 217, 217);
  justify-content:space-between;
}

.default {
  padding: 3px 6px 3px 6px;
  background: rgb(19, 65, 19);
  border-radius: 6px;
  color: white;
  font-size: .7rem;
  margin: auto;
}

.btn {
  width:70px;
  padding: 1px;
  border: 1px solid rgb(134, 134, 134);
  border-radius: 6px;
  font-size: .6rem;
  margin: auto;
}

.btn:hover {
  background: rgb(12, 56, 110);
  color: rgb(202, 202, 202);
}

.default {
  background: rgb(79, 195, 79);
  color: rgb(19, 28, 81);
}

.not-default {
  background: rgb(174, 176, 180);
  color: rgb(30, 30, 48);
}

.icn {
 
}

.icon-div {
   display: flex;
}

</style>
